export default "__VITE_ASSET__Bz1kpVZf__"